import { useLayoutEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { logout } from '../../../features/authSlice'
import { useAppDispatch } from '../../../hooks'
import { stopSSExpensesHub } from '../../../services/ssExpensesHub'
import { stopSSAppNotificationsHub } from '../../../services/ssAppNotificationsHub'
import { stopUserNotificationsHub } from '../../../services/userNotificationsHub'

/**
 * Clears session (local + Redux + other tabs) then redirects to login.
 * Visiting /logout must work even when opened directly in the browser.
 */
export function Logout() {
  const dispatch = useAppDispatch()
  const [cleared, setCleared] = useState(false)

  useLayoutEffect(() => {
    void stopSSExpensesHub()
    void stopSSAppNotificationsHub()
    void stopUserNotificationsHub()

    try {
      const logoutChannel = new BroadcastChannel('logoutChannel')
      logoutChannel.postMessage('logout')
      logoutChannel.close()
    } catch {
      // BroadcastChannel may be unavailable in some browsers
    }

    try {
      caches.open('api-cache').then((cache) => {
        cache.keys().then((keys) => {
          keys.forEach((request) => {
            cache.delete(request)
          })
        })
      })
    } catch {
      // ignore cache API failures
    }

    localStorage.removeItem('user')
    localStorage.removeItem('originalEmail')
    localStorage.removeItem('persist:auth')
    dispatch(logout())
    setCleared(true)
  }, [dispatch])

  if (!cleared) {
    return null
  }

  return <Navigate to='/auth/login' replace />
}
